const ar = {
  nav: {
    home: "الرئيسية",
    intelligenceLayers: "طبقات الاستخبارات",
    dataFlow: "تدفق البيانات",
    portalLogin: "دخول البوابة",
    language: "EN",
    // Legacy keys retained
    coreServices: "الخدمات الأساسية",
    extendedServices: "الخدمات الموسعة",
    dataStreams: "مصادر البيانات",
    apiIntegration: "واجهة برمجة التطبيقات",
    about: "حول وتواصل",
  },
  hero: {
    badge: "تحت إشراف الشرطة الوطنية | نظام مراقبة الحدود",
    title: "الأمين",
    subtitle: "نظام رصد الأنشطة والأحداث والكيانات الوطنية",
    arabicTitle: "Al-Ameen — Activity Monitoring for Events & Entities Nationally",
    tagline: "الحارس الأمين للوطن",
    arabicTagline: "The Nation's Trusted Guardian",
    description: "منصة مركزية لجمع البيانات تستقبل بيانات الأحداث في الوقت الفعلي من الجهات الخارجية في جميع أنحاء الوطن. تعزيز استخبارات الأمن الوطني من خلال 14 مصدر بيانات متكامل تحت نظام مراقبة الحدود.",
    exploreServices: "استكشف الخدمات",
    apiDocs: "توثيق واجهة البرمجة",
    hospitalityApp: "تطبيق الأمين للضيافة",
    hospitalityNote: "نظام إدارة فندقي مجاني للفنادق الصغيرة",
  },
  counters: {
    events: "الأحداث المعالجة",
    alerts: "التنبيهات النشطة",
    sources: "مصادر البيانات",
    entities: "الجهات المسجلة",
  },
  services: {
    title: "مصادر تجميع البيانات",
    subtitle: "14 مصدر استخباراتي متكامل يغذي إطار الأمن الوطني",
    coreBadge: "أساسي",
    extendedBadge: "موسع",
    showEvents: "عرض الأحداث",
    hideEvents: "إخفاء الأحداث",
    core: {
      hotel: {
        category: "الاستخبارات الأساسية",
        title: "الاستخبارات الفندقية",
        description: "مراقبة فورية لحجوزات الفنادق وأحداث تسجيل الدخول والخروج وتغييرات الغرف وتنقلات النزلاء في جميع المنشآت الفندقية المسجلة.",
        events: ["إنشاء حجز", "تعديل حجز", "إلغاء حجز", "تسجيل دخول النزيل", "تسجيل خروج النزيل", "تغيير الغرفة", "مغادرة مبكرة", "تمديد الإقامة"],
      },
      carRental: {
        category: "الاستخبارات الأساسية",
        title: "مراقبة تأجير السيارات",
        description: "تتبع شامل لدورة حياة تأجير المركبات بما في ذلك الحجوزات والاستلام والتمديد والإعادة من جميع شركات التأجير المرخصة.",
        events: ["حجز تأجير", "استلام المركبة", "تمديد التأجير", "إعادة المركبة", "تعديل العقد", "تقرير الأضرار"],
      },
      mobile: {
        category: "الاستخبارات الأساسية",
        title: "مشغلو الاتصالات",
        description: "إدارة دورة حياة شريحة الاتصال وتتبع IMEI وتفعيل eSIM ومراقبة أحداث التجوال الدولي من جميع مشغلي الاتصالات المرخصين.",
        events: ["تفعيل الشريحة", "إلغاء الشريحة", "تسجيل IMEI", "توفير eSIM", "تفعيل التجوال", "نقل الرقم", "استبدال الشريحة"],
      },
      municipality: {
        category: "الاستخبارات الأساسية",
        title: "سجل البلديات",
        description: "أحداث دورة حياة عقود الإيجار بما في ذلك تسجيل العقود الجديدة والتجديدات والإنهاءات من السلطات البلدية في جميع المحافظات.",
        events: ["بدء الإيجار", "تجديد الإيجار", "إنهاء الإيجار", "نقل الملكية", "تغيير المستأجر", "تحديث العنوان"],
      },
    },
    extended: {
      payment: {
        category: "الاستخبارات المالية",
        title: "الاستخبارات المالية",
        description: "مراقبة معاملات الصرافة وفتح الحسابات والتحويلات البنكية ومعاملات النقد الكبيرة من المؤسسات المالية.",
        events: ["صرف العملات", "فتح حساب", "تحويل بنكي", "إيداع نقدي كبير", "سحب نقدي كبير", "تنبيه معاملة مشبوهة"],
      },
      borders: {
        category: "مراقبة الحدود",
        title: "الحدود والهجرة",
        description: "تغذية أحداث الدخول والخروج من أنظمة مراقبة الحدود وeVisa ومراقبة الامتثال للتأشيرة واكتشاف تجاوز مدة الإقامة.",
        events: ["تسجيل الدخول", "تسجيل الخروج", "إصدار تأشيرة", "انتهاء تأشيرة", "تنبيه تجاوز المدة", "تفعيل التأشيرة الإلكترونية", "عبور الحدود"],
      },
      health: {
        category: "المراقبة الصحية",
        title: "التفاعلات الصحية",
        description: "أحداث تسجيل المرضى والقبول في حالات الطوارئ وصرف الوصفات الطبية والتفاعلات مع المرافق الصحية.",
        events: ["تسجيل المريض", "قبول طارئ", "إصدار وصفة", "الخروج من المستشفى", "إنشاء إحالة", "طلب فحص مختبري"],
      },
      utility: {
        category: "البنية التحتية",
        title: "تفعيل المرافق",
        description: "إعداد خدمات الكهرباء والمياه والإنترنت وتعديلاتها وإنهاؤها المرتبطة بالعناوين السكنية والتجارية.",
        events: ["توصيل الكهرباء", "توصيل المياه", "تفعيل الإنترنت", "تعديل الخدمة", "إنهاء الخدمة", "ربط العنوان"],
      },
      transport: {
        category: "استخبارات التنقل",
        title: "النقل العام",
        description: "أنماط استخدام الحافلات والتاكسي ومراقبة المسارات وبيانات التفاعل مع وسائل النقل العام من مشغلي النقل الوطنيين.",
        events: ["رحلة حافلة", "حجز تاكسي", "تنبيه نمط مسار", "مسار متكرر", "سفر بين المحافظات"],
      },
      education: {
        category: "سجل التعليم",
        title: "التسجيل التعليمي",
        description: "أحداث تسجيل الطلاب وتمديدات التأشيرة الأكاديمية وتسجيل المؤسسات التعليمية من جميع المؤسسات المرخصة.",
        events: ["تسجيل الطالب", "تمديد التأشيرة", "نقل المؤسسة", "تسجيل التخرج", "تنبيه الانسحاب"],
      },
      employment: {
        category: "استخبارات العمل",
        title: "سجل التوظيف",
        description: "إصدار تصاريح العمل وتغييرات صاحب العمل وأحداث عقود العمل وتحديثات حالة التوظيف من وزارة العمل.",
        events: ["إصدار تصريح عمل", "تغيير صاحب العمل", "توقيع عقد", "إنهاء عقد", "تجديد التصريح", "إلغاء التصريح"],
      },
      ecommerce: {
        category: "استخبارات التجارة",
        title: "التجارة الإلكترونية والتجزئة",
        description: "مراقبة المعاملات الإلكترونية واكتشاف المشتريات بالجملة ونشاط منصات التجارة الإلكترونية من التجار الرقميين المسجلين.",
        events: ["شراء إلكتروني", "تنبيه طلب بالجملة", "معاملة عالية القيمة", "تسجيل تاجر", "معالجة استرداد"],
      },
      social: {
        category: "الاستخبارات الرقمية",
        title: "استخبارات وسائل التواصل",
        description: "ربط أرقام الهاتف بحسابات التواصل الاجتماعي ومراقبة الكلمات المفتاحية العامة وتحليل البصمة الرقمية للأمن الوطني.",
        events: ["ربط هاتف-اجتماعي", "تنبيه كلمة مفتاحية", "نشاط الحساب", "تنبيه منشور عام", "تحليل الشبكة"],
      },
      customs: {
        category: "الجمارك والتجارة",
        title: "الجمارك والشحن",
        description: "إقرارات الاستيراد والتصدير وبيانات الشحن ومراقبة البضائع المقيدة واكتشاف غسيل الأموال القائم على التجارة من سلطات الجمارك.",
        events: ["إقرار استيراد", "إقرار تصدير", "تقديم بيان الشحن", "تنبيه بضائع مقيدة", "اكتشاف نمط TBML", "تخليص جمركي", "تفتيش شحنة"],
      },
      marine: {
        category: "الاستخبارات البحرية",
        title: "البحرية والملاحة",
        description: "تسجيلات رسو المراسي وتتبع تأجير القوارب ومراقبة أنشطة الغوص واستخبارات حركة السفن من السلطات الساحلية والبحرية.",
        events: ["رسو المرسى", "تأجير قارب", "تسجيل غوص", "مغادرة سفينة", "وصول سفينة", "تصريح صيد", "حادثة بحرية"],
      },
      postal: {
        category: "الاستخبارات البريدية",
        title: "الخدمات البريدية",
        description: "تسجيلات صناديق البريد وتتبع استلام الطرود ومراقبة البريد الدولي واكتشاف الطرود المشبوهة من سلطات البريد الوطنية.",
        events: ["تسجيل صندوق بريد", "استلام طرد", "طرد دولي", "تنبيه طرد مشبوه", "تنبيه بريد جماعي", "التحقق من العنوان"],
      },
    },
  },
  architecture: {
    title: "بنية تدفق البيانات",
    subtitle: "خط أنابيب بيانات آمن متعدد الطبقات من الجهات الخارجية إلى تقييم المخاطر",
    steps: {
      entities: "الجهات الخارجية",
      api: "B2B API / بوابة الأمين",
      validation: "التحقق من الشرطة الوطنية",
      database: "قاعدة البيانات المركزية",
      vis1: "قسم الأمن 1",
      vis2: "قسم الأمن 2",
      risk: "تقييم المخاطر",
      stored: "تخزين النتائج",
    },
    warning: "نتائج المخاطر لا تُشارك أبداً مع الجهات الخارجية",
    note: "التكرار المزدوج للفحص يضمن تقييم مخاطر مستقل مع عدم تسرب البيانات",
  },
  hospitality: {
    badge: "تطبيق مكتبي مجاني",
    title: "الأمين للضيافة",
    arabicTitle: "Al-Ameen Hospitality",
    description: "نظام إدارة فندقية مستقل مصمم للفنادق الصغيرة التي لا تمتلك نظام إدارة عقارات خاص بها. يزامن البيانات مع الأمين في الخلفية — منتج مستقل تماماً بتسجيل دخول خاص به.",
    features: ["إدارة الحجوزات والاستفسارات", "تخصيص الغرف والتدبير المنزلي", "تسجيل دخول/خروج النزلاء", "مزامنة تلقائية مع بيانات الأمين", "تطبيق مكتبي يعمل بدون إنترنت", "مجاني تماماً لجميع الفنادق الصغيرة"],
    download: "تحميل لنظام Windows",
    note: "تسجيل دخول منفصل — غير متصل ببوابة الأمين",
    separator: "منتج مستقل",
  },
  api: {
    title: "واجهة برمجة التطبيقات والتكامل",
    subtitle: "اربط أنظمتك بالأمين عبر واجهة B2B API الآمنة أو بوابة الأمين",
    b2bTitle: "تكامل B2B API",
    b2bDesc: "تكامل مباشر بين الأنظمة للجهات التي لديها أنظمة قائمة. واجهة RESTful مع مصادقة JWT وبث الأحداث في الوقت الفعلي.",
    portalTitle: "بوابة الأمين",
    portalDesc: "بوابة ويب لإدخال البيانات وإدارتها يدوياً. مثالية للجهات الأصغر أو كبديل عند عدم توفر تكامل API.",
    features: {
      auth: "مصادقة JWT",
      authDesc: "مصادقة آمنة قائمة على الرمز المميز مع تدوير تلقائي",
      tls: "تشفير TLS 1.3",
      tlsDesc: "جميع البيانات أثناء النقل مشفرة بمعيار TLS 1.3",
      rate: "تحديد معدل الطلبات",
      rateDesc: "حدود معدل قابلة للتهيئة لكل جهة مع سماح بالانفجار",
      webhook: "دعم Webhook",
      webhookDesc: "إقرار الأحداث في الوقت الفعلي عبر webhooks قابلة للتهيئة",
      sandbox: "بيئة الاختبار",
      sandboxDesc: "بيئة اختبار كاملة تعكس واجهة برمجة الإنتاج",
      support: "دعم تقني 24/7",
      supportDesc: "فريق تقني مخصص من الشرطة الوطنية لمساعدة التكامل",
    },
    endpoints: "نقاط النهاية الرئيسية",
    getStarted: "ابدأ الآن",
    requestAccess: "طلب وصول API",
    viewDocs: "عرض التوثيق",
  },
  about: {
    title: "حول الأمين",
    subtitle: "حماية الوطن من خلال جمع البيانات الاستخباراتية",
    ropTitle: "الشرطة الوطنية",
    ropDesc: "الأمين مبادرة من الشرطة الوطنية، جهاز إنفاذ القانون الرئيسي في الوطن. يعمل تحت إطار نظام مراقبة الحدود للأمن الوطني، ويمثل الأمين التزام الوطن بتوظيف التكنولوجيا لخدمة الأمن الوطني.",
    ibordersTitle: "نظام مراقبة الحدود",
    ibordersDesc: "نظام مراقبة الحدود هو منصة الشرطة الوطنية الشاملة للحدود الرقمية والأمن الوطني. يعمل الأمين كعمود فقري لاستخبارات البيانات، يجمع ويعالج الأحداث من 14 مصدر بيانات وطني لدعم قرارات الأمن القائمة على الأدلة.",
    missionTitle: "مهمتنا",
    missionDesc: "توفير منصة بيانات استخباراتية موحدة وفورية للشرطة الوطنية تمكن من إدارة الأمن الوطني الاستباقية مع الحفاظ على أعلى معايير سلامة البيانات والخصوصية.",
    contactTitle: "التواصل والدعم",
    contactDesc: "لطلبات الوصول إلى API والدعم التقني والاستفسارات العامة حول تكامل الأمين.",
    form: {
      name: "الاسم الكامل",
      namePlaceholder: "اسمك الكامل",
      email: "البريد الإلكتروني",
      emailPlaceholder: "your@organization.gov",
      organization: "المنظمة",
      orgPlaceholder: "اسم منظمتك",
      subject: "الموضوع",
      subjectPlaceholder: "اختر موضوعاً",
      subjects: ["طلب وصول API", "الدعم التقني", "استفسار تكامل", "استفسار عام", "الأمين للضيافة"],
      message: "الرسالة",
      messagePlaceholder: "صف استفسارك بالتفصيل...",
      submit: "إرسال الرسالة",
      sending: "جارٍ الإرسال...",
      success: "تم إرسال الرسالة بنجاح. سيرد فريقنا خلال 24 ساعة.",
      error: "فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.",
    },
  },
  footer: {
    tagline: "الحارس الأمين للوطن",
    arabicTagline: "The Nation's Trusted Guardian",
    description: "منصة مركزية لجمع البيانات الاستخباراتية الوطنية تحت إشراف الشرطة الوطنية.",
    quickLinks: "روابط سريعة",
    links: {
      apiDocs: "توثيق API",
      integrationGuide: "دليل التكامل",
      supportPortal: "بوابة الدعم",
      statusPage: "حالة النظام",
      hospitality: "الأمين للضيافة",
    },
    contact: "تواصل مع الشرطة الوطنية",
    phone: "+968 2456 0000",
    email: "support@alameen.gov",
    address: "مقر الشرطة الوطنية، قسم نظام مراقبة الحدود",
    copyright: "© 2025 الشرطة الوطنية. جميع الحقوق محفوظة.",
    privacy: "سياسة الخصوصية",
    terms: "شروط الخدمة",
    operated: "يعمل تحت مظلة نظام مراقبة الحدود",
  },
};

export default ar;
